export enum ProjectStatus {
  ProposalDraft = 0,
  ProposalDesign,
  ProposalClosed,
  ProjectInitiated,
  ProjectInProgressTendering,
  ProjectInProgressExecution,
  ProjectHandoverClosed,
}
